import request from '@/utils/zsm-requets'
const good = '/zsm/api/good/'
/*
查看商品详情
 */
export function getGood(params) {
    return request({
        url: good + 'getFormCache',
        method: 'post',
        params
    })
}

/**
 * 查看课程的观看条件
 * @param  goodId 商品Id
 */
export function findGoodDetailLookFlag(goodId) {
    return request({
        url: good + 'findGoodDetailLookFlag',
        method: 'get',
        params:{goodId}
    })
}